import { Injectable } from '@angular/core';
import {
  Router,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  NavigationExtras
} from '@angular/router';
import { TdLoadingService } from '@covalent/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';

import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
  /**
   * Constructor
   *
   * @param _router
   * @param _loadingService
   * @param _authService
   */
  constructor(
    private _router: Router,
    private _loadingService: TdLoadingService,
    private _authService: AuthService
  ) {}

  /**
   *
   * @param route
   * @param state
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkLogin(state.url);
  }

  /**
   *
   * @param route
   * @param state
   */
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(route, state);
  }

  /**
   *
   * @param url
   */
  async checkLogin(url: string) {
    const ssoUrl = environment.ssoUrl
    const logged = await this._authService.isLoggedIn().toPromise();
    if (logged) return true;
    this._authService.redirectUrl = url;
    ///public   `https://sso.municipal.gov.ge/public/auth/login?redirectUrl=${document.location.href}`;
    document.location.href = `${ssoUrl}/public/auth/login?redirectUrl=${document.location.href}`;
    return false;
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/services/auth-guard.service.ts